<div class="page-container">

  <!-- <ua-trh-navigation></ua-trh-navigation> -->

  <div class="header-wrap">
    <ua-header [showBackButton]="showBackButton" (navigateBack)="goBack()"></ua-header>
  </div>
  <div role='main'>
    <div class="container no-padding form-group hero">
      <ua-hero *ngIf="!showFlightLookupForm">
        <div class="alert-wrap">
          <!--<ua-alert-msg *ngIf="!showErrorMessage" [mode]="'info'" [message]="commonConstants[paymentMessage]">
          </ua-alert-msg>-->
          <ua-alert-msg *ngIf="showErrorMessage" [mode]="'error'" [message]="pageConstants[errorMessage]"></ua-alert-msg>
        </div>
        <div class='overlay'>
          <h4 aria-level='1' class="title">{{pageConstants.title}}</h4>
          <div class="info"><span >{{pageConstants[info]}}</span></div>
        </div>
      </ua-hero>

      <div *ngIf="showFlightLookupForm" class="container header-wrap">
        <h4 aria-level="1" class="title">{{preChatConstants.title}}</h4>
        <div class="message-wrap">
            <p>{{ pageConstants.easySearchError }}</p>
        </div>
      </div>

    </div>
    <div class="container">
      <div class="tab-wrap">

        <div class="error-scan-timeout" *ngIf="showErrorScanTimeout">
          <div class="est-l">
            <div class="est-message">
              We were not able to read your boarding pass. Please try to scan again or type your information manually.
            </div>
          </div>
        </div>
        
        <div class="boarding-pass-scan" *ngIf="showBoardingPassScan">
          <div class="outline-btn-wrap">
            <button type = "button" (click)="startScanning()" class="btn scan col-sm-12 col-md-12 col-lg-12">
              <div class="btn-content">
                <div class="icon-wrap">
                    <img alt="" src="./../../../assets/camera.svg"/>
                </div>
                <span class="btn-text">{{pageConstants.scan}}</span>
              </div>
            </button>
          </div>
          <div class="seperator-wrap">
            <h4>{{pageConstants.or}}</h4>
          </div>
        </div>  

        <!--<div class="info-block">
          {{pageConstants.chatLabel}}
        </div>-->
        <!--<nav class="nav nav-pills flex-column">
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="nav-link" id="nav-lookup-tab" data-bs-toggle="tab" data-bs-target="#nav-lookup"
              type="button" role="tab" aria-controls="nav-lookup"
              aria-selected="true">{{pageConstants.confirmationNumber}}</button>
            <button class="nav-link active" id="nav-search-tab" data-bs-toggle="tab" data-bs-target="#nav-search" type="button"
              role="tab" aria-controls="nav-search" aria-selected="false">{{pageConstants.reservationLookUp}}</button>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade" id="nav-lookup" role="tabpanel" aria-labelledby="nav-lookup-tab">
            <ua-flight-lookup-form (errorMessageEmitter)="isSearchError($event)"></ua-flight-lookup-form>
          </div>
          <div class="tab-pane fade show active" id="nav-search" role="tabpanel" aria-labelledby="nav-search-tab">
            <ua-flight-search-form (errorMessageEmitter)="isSearchError($event)"></ua-flight-search-form>
          </div>
        </div>-->

        <div class="welcome-content">
          <ua-flight-lookup-form [hidden]="!showFlightLookupForm" (errorMessageEmitter)="isSearchError($event)"></ua-flight-lookup-form>
          <ua-flight-search-form [hidden]="showFlightLookupForm" (errorMessageEmitter)="isSearchError($event)"></ua-flight-search-form>
          <div *ngIf="isScanningInProgress" class="scanning-modal">
            <ua-barcode-scanner
              (scannerClosed)="onScannerClose()"
              (scannerResult)="onScannerResult($event)"
              (scannerTimeout)="onScannerTimeout()"
            ></ua-barcode-scanner>
          </div>          
        </div>
        
      </div>
    </div>
  </div>
</div>
